<template lang="pug">
section.compliance(
    v-if="complianceElement"
    v-html="complianceElement.html"
    :style="complianceElement.style"
)
</template>

<script>
export default {
    name: 'Compliance',

    props: {
        type: {
            type: String,
            required: true,
        },
        config: {
            type: Object,
            required: true,
        }
    },

    computed: {
        complianceElement() {
            if (!['header', 'footer'].includes(this.type)) return undefined;

            const data = (this.config.compliance || {})[this.type];
            if (!data) return undefined;

            const html = this.getLocalizedText(data);
            if (!html) return undefined;

            return { style: this.getStyleString(data), html };
        }
    },

    methods: {
        /**
         * Resolves the text to display, keeping the registration page in sync with Backstage
         * and the web app.
         *
         * Backstage stores the default language in the root `text` and only the other
         * languages in `content`, so the root field is authoritative for the default
         * language. Anything else in `content` — a language dropped from the event, or a
         * `content` bucket left over from when the event was multilingual — is stale.
         */
        getLocalizedText(data) {
            const languages = this.config.event_details?.languages || [];
            const locale = this.$i18n.locale;

            if (languages.length > 1 && locale !== languages[0] && languages.includes(locale)) {
                return data.content?.[locale]?.text || data.text;
            }

            return data.text;
        },

        getStyleString(data) {
            const borderWidth = (data.custom_colors ? (data.border_pixels || 1) : 1) + 'px';
            const primaryColor = this.config?.theme?.button_background_color;
            const style = {
                border: `solid ${borderWidth} #DDD`,
                color: '#333',
                'background-color': '#FFF',
                '--link-color': primaryColor || '#0066CC',
            };
            if (data.custom_colors) {
                if (data.border_color) { style.border = `solid ${borderWidth} ${data.border_color}`; }
                if (data.text_color) { style.color = data.text_color; }
                if (data.background_color) { style['background-color'] = data.background_color; }
                if (data.link_color) { style['--link-color'] = data.link_color; }
            }
            return Object.entries(style).map(([k, v]) => `${k}:${v}`).join(';');
        }
    }
}
</script>
